import React, { useState } from "react";
import StatusBar from "components/StatusBar";
import Card from "components/Card";
import CardHeader from "components/CardHeader";
import Button from "components/Button";
import { useMutation } from "@apollo/client";
import {
  BILL_TO_ROOM,
  ADD_VOUCHER,
  REDEEM_VOUCHER
} from "graphql/service";
import { debouncedErrorMessage } from "utils/messageUtil";
import moment from "moment-timezone";
import { TIME_ZONE } from "constants/constant";
import { message } from "antd";
import { InfoContainer, VoucherContainer } from "./styles";
import colors from "constants/colors";

const BookingInformation = ({ booking, refetch }) => {

  const [billToRoom, { loading: billToRoomLoading }] = useMutation(BILL_TO_ROOM, {
    onCompleted: (data) => {
      message.success("Successfully billed to room");
      refetch();
    },
    onError: (error) => {
      if (!error.networkError) {
        let content = error.message
        if(error.message.includes('Validation')) {
            content = JSON.stringify(error.graphQLErrors[0]?.extensions?.exception)
        }
        debouncedErrorMessage(content);
      }
    }
  });

  const handleBillToRoom = () => {
    billToRoom({
      variables: {
        bookingId: booking.bookingId,
      }
    })
  };

  const [addVoucher, { loading: addVoucherLoading }] = useMutation(ADD_VOUCHER, {
  });

  const handleAddVoucher = (e) => {
    addVoucher({
      variables: {
        bookingId: booking.bookingId,
        voucherId: e.target.value,
      }
    })
  };

  const [redeemVoucher, { loading: redeemVoucherLoading }] = useMutation(REDEEM_VOUCHER, {
  });

  const handleRedeemVoucher = () => {
    redeemVoucher({
      variables: {
        bookingId: booking.bookingId,
      }
    })
  };

  return (
    <Card>
      <CardHeader>
        <div className="cardTitle">
          <div>
            <span>ROOM {booking.roomBookings[0]?.room?.roomNumber} </span>
            <span className="greyOut">
              {booking.roomBookings[0]?.room?.roomType?.name}
            </span>
          </div>
          <StatusBar status={booking.status} />
        </div>
      </CardHeader>
      <InfoContainer>
        <div className="name">
          <div className="label">NAME</div>
          <div className="value">{booking.guest?.name}</div>
        </div>
        <div className="email">
          <div className="label">EMAIL</div>
          <div className="value">{booking.guest?.email}</div>
        </div>
        <div className="phone">
          <div className="label">PHONE</div>
          <div className="value">{booking.guest?.phone}</div>
        </div>
        <div className="checkInDate">
          <div className="label">CHECK-IN</div>
          <div className="value">
            <span>{moment(booking.checkInDate).tz(TIME_ZONE).format("MM/DD/YYYY")}</span>
            <span>{moment(booking.checkInDate).tz(TIME_ZONE).format("hh:mm A")}</span>
          </div>
        </div>
        <div className="checkOutDate">
          <div className="label">CHECK-OUT</div>
          <div className="value">
            <span>{moment(booking.checkOutDate).tz(TIME_ZONE).format("MM/DD/YYYY")}</span>
            <span>{moment(booking.checkOutDate).tz(TIME_ZONE).format("hh:mm A")}</span>
          </div>
        </div>
      </InfoContainer>
      <Card
        additionalstyle={`
          border-top: 1px solid ${colors.darkGrey};
          border-bottom: 1px solid ${colors.darkGrey};
          margin-top: 16px;
        `}
      >
        <CardHeader>
          <div className="cardTitle">
            CAFE ACTIONS
          </div>
          <div className="buttonContainer">
            <Button
              mainPage
              onClick={handleBillToRoom}
              data-loading={billToRoomLoading}
              additionalstyle={`
                width: 104px;
              `}
            >
              {billToRoomLoading ? null: 'Bill to Room'}
            </Button>
          </div>
        </CardHeader>
        <CardHeader>
          <div className="cardTitle">
            BREAKFAST VOUCHERS
          </div>
          <div className="buttonContainer">
            <Button
              mainPage
              success
              disabled={booking.voucher?.redeemed === booking.voucher?.amount}
              onClick={handleRedeemVoucher}
              data-loading={redeemVoucherLoading}
              additionalstyle={`
                width: 130px;
              `}
            >
              {redeemVoucherLoading ? null: 'Redeem Voucher'}
            </Button>
            <Button
              mainPage
              onClick={handleAddVoucher}
              data-loading={addVoucherLoading}
              additionalstyle={`
                width: 106px;
                margin-left: 16px;
              `}
            >
              {addVoucherLoading ? null: 'Add Voucher'}
            </Button>
          </div>
        </CardHeader>
        <VoucherContainer>
          <div className="total">
            <div className="label">TOTAL</div>
            <div className="value">{booking.voucher?.amount || 0}</div>
          </div>
          <div className="redeemed">
            <div className="label">REDEEMED</div>
            <div className="value">{booking.voucher?.redeemed || 0}</div>
          </div>
        </VoucherContainer> 
      </Card>
    </Card>
  );
};

export default BookingInformation;
